<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useScrollStore } from "@/stores/storeScroll";
import { useRequestsStore } from "@/stores/storeRequests";
import { useSettingsStore } from "@/stores/storeSettings";
import { useGameHistory } from "@/composables/useGameHistory";
import { useQuizMatchesStore } from "@/stores/storeQuizMatches";
import { RouterLink } from "vue-router";
import ProfileFilter from "@/components/profile/ProfileFilter.vue";
import ProfileUserData from "@/components/profile/ProfileUserData.vue";
import ProfileUserReceipts from "@/components/profile/ProfileUserReceipts.vue";
import ProfileUserPrizes from "@/components/profile/ProfileUserPrizes.vue";
import ProfileUserTickets from "@/components/profile/ProfileUserTickets.vue";
import ProfileUserBalance from "@/components/profile/ProfileUserBalance.vue";
import ProfileUserShowcasePrizes from "@/components/profile/ProfileUserShowcasePrizes.vue";
import TheLine from "@/components/sections/TheLine.vue";
import ProfileQuizMatchBanner from "@/components/profile/ProfileQuizMatchBanner.vue"; 
import ProfileQuizWordsBanner from "@/components/profile/ProfileQuizWordsBanner.vue";
import BaseButtonUploadReceipt from "@/components/ui/BaseButtonUploadReceipt.vue";

const storeScroll = useScrollStore();
const storeSettings = useSettingsStore();
const storeRequests = useRequestsStore();
const storeQuizMatches = useQuizMatchesStore();
const { initTimer } = useGameHistory();
onMounted( async() => {
	await initTimer();
});
</script>
<template>
	<section class="profile" :style="{ paddingTop: storeScroll.paddingTop}">
		<div class="container-left profile__container">
			<div class="profile__nav" :style="{ top: storeScroll.paddingTop}">
				<div class="profile__filter">
					<ProfileFilter />
				</div>
			</div>
			<div class="profile__body">
				<div class="profile__section profile__user-data" id="personalData">					
					<ProfileUserData />					
				</div>
				<div class="profile-line"></div>
				<div class="profile__section profile__user-prizes --full --bottom-line" id="myPrizes">				
					<ProfileUserPrizes />					
				</div>		
				<div class="profile-line"></div>
				<div class="profile__section profile__user-receipts" id="uploadedReceipts">					
					<ProfileUserReceipts />				
				</div>
			</div>			
		</div>
		<!-- <TheLine/> -->
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.profile {
	position: relative;

	&::before {
		position: absolute;
		content: '';
		background-image: url('@/assets/img/main/profile_bg.webp');
		background-repeat: no-repeat;
		background-position: 100% 0%; /* x y*/
		background-size: auto; /* w h*/
		width: 91.5rem;
		height: 90.2rem;
		top: 0;
		right: 0;
		z-index: -1;
		opacity: 0.14;
		@media (max-width: vars.$mn) {
			display: none;
		}
	}
	@media (max-width: vars.$mn) {
		background-image: none;
	}
	&__container {
		
		display: grid;
		grid-template-columns: 30rem 1fr;
		gap: 5.5rem;
		align-items: start;
		padding-top: 1.6rem;
		padding-bottom: 15.2rem;
		@media (max-width: vars.$l) {
			
			padding-right: var(--padding-container);
			max-width: calc(144rem + var(--padding-container) * 2);
		}
		@media (max-width: vars.$mn) {
			display: flex;
			flex-direction: column;
			// gap: 0;
		}
		@media (max-width: vars.$x480) {
			padding-top: 2.2rem;
			padding-bottom: 5.2rem;
			gap: 0.5rem;
		}
	}

	&__nav {
		width: 100%;
		position: sticky;
		top: 0;
		z-index: 2;
		background-color: #0D2E1A;
		
		@media (max-width: vars.$xx) {
			
			
		}
		&::before {
			position: absolute;
			content: '';
		    height: 150px;
    		top: -150px;
			left: 0;
			right: calc(var(--padding-container) * -1);
			background-color: #0D2E1A;
			display: none;
			@media (max-width: vars.$mn) {
				display: block;
			}
		}
	}
	
	&__filter {
		@media (max-width: vars.$xx) {
			overflow-x: auto;	
			padding-bottom: 1rem;
			margin-right: -20px;
		}
	}

	&__games-banner {
		@media (max-width: vars.$mn) {
			display: none;
		}
	}

	&__body {
		display: flex;
		flex-direction: column;
		gap: 4rem;
		@media (max-width: vars.$mn) {
			width: 100%;
		}
	}

	&__section {
		max-width: 108.5rem;
		@media (max-width: vars.$lg) {
			
		}
		@media (max-width: vars.$l) {
			max-width: 100%;
			width: 100%;
			
		}
		&.--full {
			max-width: 133rem;
			@media (max-width: vars.$l) {
				max-width: 98rem;
			}
			@media (max-width: vars.$t) {
				max-width: 80rem;
			}
			@media (max-width: vars.$mn) {
				max-width: 100%;
			}
		}
		
	}

	&__user-data {
	}

	&__user-games-banner{
		display: none;
		@media (max-width: vars.$mn) {
			display: grid;
			grid-template-columns: 300px;
			align-items: start;
			// gap: 2rem;
			justify-content: center;
		}
		@media (max-width: vars.$x480) {
			grid-template-columns: 360px;
		}
		@media (max-width: vars.$x425) {
			display: block;
			width: 100%;
		}
	}

	&__user-info {
		display: grid;
		gap: 20px;
	}

	&__user-prizes {
	}

	&__user-showcase-prizes{
	}

	&__user-receipts {
	}
}

.profile-line {
	background: var(--border-accent-2-1);
	height: 1px;
	max-width: 108.5rem;
	width: 100%;
	@media (max-width: vars.$l) {
		max-width: 100%;
	}
}

.v-enter-active,
.v-leave-active {
	transition: 0.5s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
	transform: translateY(10px);
}
</style>
